// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.order-items-list {
    margin-bottom: 25px;
  }
  
  .order-items-list h3 {
    margin: 0 0 15px 0;
    color: #080808;
    font-size: 16px;
  }
  
  .no-items {
    text-align: center;
    padding: 30px;
    color: #0c0c0c;
    font-style: italic;
    background-color: #f9f9f9;
    border-radius: 8px;
  }
  
  .items-container {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
  }
  
  .items-container::-webkit-scrollbar {
    width: 6px;
  }
  
  .items-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  .items-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
  
  .items-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  
  
  .order-item-card {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    transition: all 0.2s;
  }
  
  .order-item-card:hover {
    border-color: #edec5b;
    box-shadow: 0 2px 4px rgba(108, 92, 231, 0.1);
  }
  
  .order-item-card.editing {
    border: 2px solid #edec5b;
    background-color: #f0ebff;
  }
  
  
  .item-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #dee2e6;
  }
  
  .item-number {
    background-color: #edec5b;
    color: rgb(7, 7, 7);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 10px;
  }
  
  .item-system {
    font-weight: 600;
    color: #333;
    flex: 1 1;
    font-size: 13px;
  }
  
  .item-actions {
    display: flex;
    gap: 5px;
  }
  
  .item-edit-btn, .item-remove-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    padding: 2px 5px;
    border-radius: 4px;
    transition: all 0.2s;
  }
  
  .item-edit-btn {
    color: #edec5b;
  }
  
  .item-edit-btn:hover {
    background-color: #e9ecef;
  }
  
  .item-remove-btn {
    color: #dc3545;
  }
  
  .item-remove-btn:hover {
    background-color: #f8d7da;
  }
  
  
  .item-details {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    flex-wrap: wrap;
  }
  
  
  .item-details-left {
    flex: 1 1;
    min-width: 180px;
  }
  
  
  .item-details-right {
    flex-shrink: 0;
    text-align: right;
  }
  
  
  .item-detail {
    display: flex;
    align-items: center;
    padding: 3px 0;
    border-bottom: none !important;
  }
  
  
  .item-details-left .item-detail {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }
  
  .item-details-left .detail-label {
    width: 85px;
    flex-shrink: 0;
    color: #0c0c0c;
    font-size: 11px;
    font-weight: 500;
    text-align: left;
  }
  
  .item-details-left .detail-value {
    flex: 1 1;
    color: #050505;
    font-size: 11px;
    font-weight: 600;
    text-align: left;
    word-break: break-word;
  }
  
  
  .item-details-right .item-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 3px 0;
    border-bottom: none !important;
  }
  
  .item-details-right .detail-label {
    color: #050505;
    font-size: 11px;
    font-weight: 500;
    text-align: right;
  }
  
  .item-details-right .detail-value {
    color: #080808;
    font-size: 12px;
    font-weight: 700;
    text-align: right;
    min-width: 65px;
  }
  
  
  .item-detail.price .detail-value,
  .item-detail.sum .detail-value {
    color: #080808;
    font-weight: 700;
    font-size: 12px;
  }
  
  .item-detail.price .detail-label,
  .item-detail.sum .detail-label {
    font-weight: 600;
    font-size: 11px;
  }
  
  
  .item-detail,
  .item-detail:last-child,
  .item-details-left .item-detail,
  .item-details-right .item-detail {
    border-bottom: none !important;
  }
  
  
  .item-notes {
    flex: 0 0 100%;
    margin-top: 8px;
    padding: 6px;
    background-color: #fff3cd;
    border-radius: 4px;
    color: #856404;
    font-size: 11px;
    font-style: italic;
  }
  
  
  @media (max-width: 768px) {
    .item-details {
      flex-direction: column;
      gap: 10px;
    }
    
    .item-details-left {
      width: 100%;
    }
    
    .item-details-right {
      width: 100%;
    }
    
    .item-details-right .item-detail {
      justify-content: space-between;
    }
    
    .item-details-right .detail-label {
      text-align: left;
    }
    
    .item-details-right .detail-value {
      text-align: right;
    }
  }
.orders-list-modal {
    background-color: white;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  .orders-list-modal h2 {
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
    font-size: 20px;
  }
  
  .orders-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }
  
  .order-card {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.2s;
  }
  
  .order-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .order-card.draft {
    border-left: 4px solid #ffc107;
  }
  
  .order-card.confirmed {
    border-left: 4px solid #080808;
  }
  
  .order-card.archived {
    border-left: 4px solid #6c757d;
    opacity: 0.8;
  }
  
  .order-card-header {
    background-color: #f8f9fa;
    padding: 12px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e9ecef;
  }
  
  .order-number {
    font-weight: 600;
    color: #333;
  }
  
  .order-status {
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 12px;
    font-weight: 500;
  }
  
  .order-status.draft {
    background-color: #fff3cd;
    color: #856404;
  }
  
  .order-status.confirmed {
    background-color: #d4edda;
    color: #155724;
  }
  
  .order-status.archived {
    background-color: #e2e3e5;
    color: #383d41;
  }
  
  .order-card-body {
    padding: 15px;
  }
  
  .order-card-body div {
    margin-bottom: 6px;
    color: #080808;
    font-size: 14px;
  }
  
  .order-card-actions {
    padding: 12px 15px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e9ecef;
  }
  
  .order-card-actions button {
    flex: 1 1;
    padding: 6px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
  }
  
  .order-card-actions button:first-child {
    background-color: #edec5b;
    color: rgb(0, 0, 0);
  }
  
  .order-card-actions button:nth-child(2) {
    background-color: #070707;
    color: white;
  }
  
  .order-card-actions button:last-child {
    background-color: #ffc107;
    color: #333;
  }
  
  .order-card-actions button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .no-orders {
    text-align: center;
    padding: 40px;
    color: #6c757d;
    font-style: italic;
  }
  
  
  .my-orders-page {
    padding: 20px;
    max-width: 1600px;
    margin: 0 auto;
  }
  
  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 15px 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  
  .new-order-btn {
    padding: 10px 20px;
    background-color: #edec5b;
    color: rgb(0, 0, 0);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
  }
  
  .new-order-btn:hover {
    background-color: #f8f894;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(108, 92, 231, 0.3);
  }
  
  .dealer-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .dealer-label {
    color: #666;
    font-size: 14px;
  }
  
  .dealer-name {
    font-weight: 600;
    color: #333;
    font-size: 16px;
  }
  
  
  .dark-theme .my-orders-page {
    background-color: #ffffff;
  }
  
  .dark-theme .orders-list-modal,
  .dark-theme .order-header {
    background-color: #dcdcda;
    border-color: #404040;
  }
  
  .dark-theme .order-card {
    background-color: #b5babd;
    border-color: #404040;
  }
  
  .dark-theme .order-card-header {
    background-color: #fffefe;
  }
  
  .dark-theme .order-number,
  .dark-theme .order-card-body div {
    color: #000000;
  }
  
  .dark-theme .dealer-label {
    color: #000000;
  }
  
  .dark-theme .dealer-name {
    color: #000000;
  }
  
  
  @media (max-width: 768px) {
    .order-header {
      flex-direction: column;
      gap: 15px;
      align-items: stretch;
    }
    
    .header-left {
      flex-direction: column;
      gap: 10px;
    }
    
    .orders-grid {
      grid-template-columns: 1fr;
    }
  }
  
.my-orders-page .confirm-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
  }
  
  .my-orders-page .confirm-dialog {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .my-orders-page .confirm-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #e9ecef;
    background-color: white;
    flex-shrink: 0;
  }
  
  .my-orders-page .confirm-dialog-header h3 {
    margin: 0;
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }
  
  .my-orders-page .confirm-dialog-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #999;
    transition: color 0.2s;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  
  .my-orders-page .confirm-dialog-close:hover {
    color: #dc3545;
    background-color: #f8f9fa;
  }
  
  .my-orders-page .confirm-dialog-message {
    padding: 20px;
    overflow-y: auto;
    flex: 1 1;
    max-height: calc(80vh - 120px);
  }
  
  .my-orders-page .confirm-dialog-message::-webkit-scrollbar {
    width: 6px;
  }
  
  .my-orders-page .confirm-dialog-message::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  .my-orders-page .confirm-dialog-message::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
  
  .my-orders-page .confirm-dialog-message::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  
  .my-orders-page .confirm-dialog-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .my-orders-page .confirm-label {
    font-weight: 500;
    color: #666;
    text-align: left;
    flex: 1 1;
  }
  
  .my-orders-page .confirm-value {
    font-weight: 600;
    color: #333;
    text-align: right;
    flex: 1 1;
    margin-left: 15px;
  }
  
  .my-orders-page .confirm-dialog-line.full-width {
    justify-content: center;
    font-weight: 500;
    margin-bottom: 15px;
  }
  
  .my-orders-page .confirm-dialog-line.full-width.highlight {
    color: #080808;
    font-weight: 600;
    font-size: 16px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e9ecef;
  }
  
  .my-orders-page .confirm-dialog-line.full-width.position-title {
    color: #edec5b;
    font-weight: 600;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  
  .my-orders-page .confirm-dialog-line.indented {
    margin-left: 20px;
  }
  
  .my-orders-page .confirm-dialog-line.indented .confirm-label {
    color: #0e0d0d;
  }
  
  .my-orders-page .confirm-dialog-line.indented .confirm-value {
    color: #080808;
  }
  
  .my-orders-page .confirm-dialog-buttons {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding: 15px 20px;
    border-top: 1px solid #e9ecef;
    background-color: white;
    flex-shrink: 0;
  }
  
  .my-orders-page .confirm-dialog-buttons button {
    flex: 1 1;
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
  }
  
  .my-orders-page .confirm-dialog-buttons .confirm-btn {
    background-color: #edec5b;
    color: #333;
  }
  
  .my-orders-page .confirm-dialog-buttons .confirm-btn:hover:not(:disabled) {
    background-color: #f8f894;
  }
  
  .my-orders-page .confirm-dialog-buttons .confirm-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .my-orders-page .confirm-dialog-buttons .cancel-btn {
    background-color: #6c757d;
    color: white;
  }
  
  .my-orders-page .confirm-dialog-buttons .cancel-btn:hover {
    background-color: #5a6268;
  }
  
  
  .dark-theme .my-orders-page .confirm-dialog {
    background-color: #f7f6f6;
  }
  
  .dark-theme .my-orders-page .confirm-dialog-header {
    background-color: #faf4f4;
    border-bottom-color: #404040;
  }
  
  .dark-theme .my-orders-page .confirm-dialog-header h3 {
    color: #0e0d0d;
  }
  
  .dark-theme .my-orders-page .confirm-label {
    color: #0c0c0c;
  }
  
  .dark-theme .my-orders-page .confirm-value {
    color: #0f0f0f;
  }
  
  .dark-theme .my-orders-page .confirm-dialog-buttons {
    background-color: #fcfafa;
    border-top-color: #404040;
  }
  
.accessories-details-panel {
    margin-top: 10px;
    background-color: #6c757d;
    border-radius: 6px;
    padding: 10px;
  }
  
  
  .accessories-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    font-weight: bold;
    font-size: 12px;
    color: white;
  }
  
  .accessories-details-header span:first-child {
    flex: 3 1;
    text-align: left;
  }
  
  .accessories-details-header span:last-child {
    flex: 1 1;
    text-align: right;
  }
  
  
  .accessories-two-columns {
    display: flex;
    gap: 20px;
  }
  
  .accessories-column {
    flex: 1 1;
    display: flex;
    flex-direction: column;
  }
  
  
  .accessories-details-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .accessories-details-row:last-child {
    border-bottom: none;
  }
  
  .accessory-name {
    flex: 3 1;
    font-size: 12px;
    color: white;
    text-align: left; 
    word-break: break-word;
    padding-right: 10px;
  }
  
  .accessory-quantity {
    flex: 1 1;
    text-align: right;
    font-size: 12px;
    color: white;
    white-space: nowrap;
  }
  
  
  @media (max-width: 768px) {
    .accessories-two-columns {
      flex-direction: column;
      gap: 8px;
    }
    
    .accessories-details-header span:first-child,
    .accessory-name {
      flex: 2 1;
    }
    
    .accessories-details-header span:last-child,
    .accessory-quantity {
      flex: 0.8 1;
    }
  }

  

  
.order-info-section {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.order-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #e9ecef;
}

.order-info-row:last-child {
  border-bottom: none;
}

.order-info-row .info-label {
  font-weight: 500;
  color: #666;
}

.order-info-row .info-value {
  font-weight: 600;
  color: #333;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.draft {
  background: #fff3cd;
  color: #856404;
}

.status-badge.confirmed {
  background: #d4edda;
  color: #155724;
}

.status-badge.archived {
  background: #e2e3e5;
  color: #383d41;
}

.order-items-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.order-item-detail-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.order-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #f8f9fa;
  cursor: pointer;
  transition: background 0.2s;
}

.order-item-header:hover {
  background: #e9ecef;
}

.order-item-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.item-number {
  background: #edec5b;
  color: #333;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.item-system {
  font-weight: 600;
  color: #333;
}

.item-color {
  font-weight: normal;
  color: #666;
  margin-left: 4px;
}

.order-item-summary {
  display: flex;
  align-items: center;
  gap: 15px;
}

.item-quantity {
  color: #666;
  font-size: 13px;
}

.item-sum {
  font-weight: 700;
  color: #070707;
  font-size: 14px;
}

.expand-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  padding: 0;
}

.order-item-details {
  padding: 15px;
  border-top: 1px solid #e9ecef;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 12px;
  color: #666;
}

.detail-value {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.total-row .detail-value {
  font-weight: 700;
  color: #edec5b;
}

.total-value {
  font-size: 16px;
}


.accessories-section {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 10px;
  margin: 10px 0;
}

.accessories-title {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ddd;
}

.accessory-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 12px;
}

.accessory-name {
  flex: 2 1;
  color: #fdfdfd;
}

.accessory-quantity {
  flex: 0.5 1;
  text-align: center;
  color: #666;
}

.accessory-sum {
  flex: 0.8 1;
  text-align: right;
  font-weight: 500;
  color: #333;
}

.accessories-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #ddd;
  font-weight: 600;
  font-size: 12px;
}

.item-notes-section {
  margin-top: 10px;
  padding: 8px;
  background: #fff3cd;
  border-radius: 4px;
  font-size: 12px;
}

.notes-label {
  font-weight: 600;
  color: #856404;
  margin-right: 8px;
}

.notes-value {
  color: #856404;
}


.order-total-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 2px solid #e9ecef;
}

.total-row.final {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: #050505;
}

.order-notes-section {
  margin-top: 15px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.order-notes-section .notes-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.order-notes-section .notes-value {
  color: #555;
  white-space: pre-wrap;
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 25px;
  flex-wrap: wrap;
}

.pagination button {
  padding: 8px 14px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
}

.pagination button:hover:not(:disabled) {
  background: #edec5b;
  color: #333;
  border-color: #edec5b;
}

.pagination button.active {
  background: #edec5b;
  color: #333;
  border-color: #edec5b;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/covfile/MyOrdersPage.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;;;EAGA;IACE,SAAO;IACP,gBAAgB;EAClB;;;EAGA;IACE,cAAc;IACd,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,8BAA8B;EAChC;;;EAGA;IACE,aAAa;IACb,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;;EAGA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;;EAGA;;IAEE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;;EAGA;;;;IAIE,8BAA8B;EAChC;;;EAGA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,8BAA8B;IAChC;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;EACF;AACF;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,6BAA6B;EAC/B;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;;EAGA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;;EAGA;IACE;MACE,sBAAsB;MACtB,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,0BAA0B;IAC5B;EACF;;AAEF;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAO;IACP,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,SAAO;IACP,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;AAEF;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;;;EAGA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iDAAiD;IACjD,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;;EAGA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE;MACE,sBAAsB;MACtB,QAAQ;IACV;;IAEA;;MAEE,SAAO;IACT;;IAEA;;MAEE,WAAS;IACX;EACF;;;;;AAKF;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["\r\n.order-items-list {\r\n    margin-bottom: 25px;\r\n  }\r\n  \r\n  .order-items-list h3 {\r\n    margin: 0 0 15px 0;\r\n    color: #080808;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .no-items {\r\n    text-align: center;\r\n    padding: 30px;\r\n    color: #0c0c0c;\r\n    font-style: italic;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .items-container {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    padding-right: 5px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n  }\r\n  \r\n  \r\n  .order-item-card {\r\n    background-color: #f8f9fa;\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 8px;\r\n    padding: 12px;\r\n    margin-bottom: 10px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-item-card:hover {\r\n    border-color: #edec5b;\r\n    box-shadow: 0 2px 4px rgba(108, 92, 231, 0.1);\r\n  }\r\n  \r\n  .order-item-card.editing {\r\n    border: 2px solid #edec5b;\r\n    background-color: #f0ebff;\r\n  }\r\n  \r\n  \r\n  .item-header {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    padding-bottom: 8px;\r\n    border-bottom: 1px dashed #dee2e6;\r\n  }\r\n  \r\n  .item-number {\r\n    background-color: #edec5b;\r\n    color: rgb(7, 7, 7);\r\n    padding: 2px 8px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .item-system {\r\n    font-weight: 600;\r\n    color: #333;\r\n    flex: 1;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .item-actions {\r\n    display: flex;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .item-edit-btn, .item-remove-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    padding: 2px 5px;\r\n    border-radius: 4px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .item-edit-btn {\r\n    color: #edec5b;\r\n  }\r\n  \r\n  .item-edit-btn:hover {\r\n    background-color: #e9ecef;\r\n  }\r\n  \r\n  .item-remove-btn {\r\n    color: #dc3545;\r\n  }\r\n  \r\n  .item-remove-btn:hover {\r\n    background-color: #f8d7da;\r\n  }\r\n  \r\n  \r\n  .item-details {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  \r\n  .item-details-left {\r\n    flex: 1;\r\n    min-width: 180px;\r\n  }\r\n  \r\n  \r\n  .item-details-right {\r\n    flex-shrink: 0;\r\n    text-align: right;\r\n  }\r\n  \r\n  \r\n  .item-detail {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 3px 0;\r\n    border-bottom: none !important;\r\n  }\r\n  \r\n  \r\n  .item-details-left .item-detail {\r\n    display: flex;\r\n    align-items: baseline;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .item-details-left .detail-label {\r\n    width: 85px;\r\n    flex-shrink: 0;\r\n    color: #0c0c0c;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    text-align: left;\r\n  }\r\n  \r\n  .item-details-left .detail-value {\r\n    flex: 1;\r\n    color: #050505;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    text-align: left;\r\n    word-break: break-word;\r\n  }\r\n  \r\n  \r\n  .item-details-right .item-detail {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 12px;\r\n    padding: 3px 0;\r\n    border-bottom: none !important;\r\n  }\r\n  \r\n  .item-details-right .detail-label {\r\n    color: #050505;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    text-align: right;\r\n  }\r\n  \r\n  .item-details-right .detail-value {\r\n    color: #080808;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    text-align: right;\r\n    min-width: 65px;\r\n  }\r\n  \r\n  \r\n  .item-detail.price .detail-value,\r\n  .item-detail.sum .detail-value {\r\n    color: #080808;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .item-detail.price .detail-label,\r\n  .item-detail.sum .detail-label {\r\n    font-weight: 600;\r\n    font-size: 11px;\r\n  }\r\n  \r\n  \r\n  .item-detail,\r\n  .item-detail:last-child,\r\n  .item-details-left .item-detail,\r\n  .item-details-right .item-detail {\r\n    border-bottom: none !important;\r\n  }\r\n  \r\n  \r\n  .item-notes {\r\n    flex: 0 0 100%;\r\n    margin-top: 8px;\r\n    padding: 6px;\r\n    background-color: #fff3cd;\r\n    border-radius: 4px;\r\n    color: #856404;\r\n    font-size: 11px;\r\n    font-style: italic;\r\n  }\r\n  \r\n  \r\n  @media (max-width: 768px) {\r\n    .item-details {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .item-details-left {\r\n      width: 100%;\r\n    }\r\n    \r\n    .item-details-right {\r\n      width: 100%;\r\n    }\r\n    \r\n    .item-details-right .item-detail {\r\n      justify-content: space-between;\r\n    }\r\n    \r\n    .item-details-right .detail-label {\r\n      text-align: left;\r\n    }\r\n    \r\n    .item-details-right .detail-value {\r\n      text-align: right;\r\n    }\r\n  }\r\n.orders-list-modal {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 25px;\r\n    margin-bottom: 30px;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n  }\r\n  \r\n  .orders-list-modal h2 {\r\n    margin-top: 0;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .orders-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n  }\r\n  \r\n  .order-card {\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-card:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .order-card.draft {\r\n    border-left: 4px solid #ffc107;\r\n  }\r\n  \r\n  .order-card.confirmed {\r\n    border-left: 4px solid #080808;\r\n  }\r\n  \r\n  .order-card.archived {\r\n    border-left: 4px solid #6c757d;\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  .order-card-header {\r\n    background-color: #f8f9fa;\r\n    padding: 12px 15px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid #e9ecef;\r\n  }\r\n  \r\n  .order-number {\r\n    font-weight: 600;\r\n    color: #333;\r\n  }\r\n  \r\n  .order-status {\r\n    font-size: 12px;\r\n    padding: 3px 8px;\r\n    border-radius: 12px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .order-status.draft {\r\n    background-color: #fff3cd;\r\n    color: #856404;\r\n  }\r\n  \r\n  .order-status.confirmed {\r\n    background-color: #d4edda;\r\n    color: #155724;\r\n  }\r\n  \r\n  .order-status.archived {\r\n    background-color: #e2e3e5;\r\n    color: #383d41;\r\n  }\r\n  \r\n  .order-card-body {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .order-card-body div {\r\n    margin-bottom: 6px;\r\n    color: #080808;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .order-card-actions {\r\n    padding: 12px 15px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e9ecef;\r\n  }\r\n  \r\n  .order-card-actions button {\r\n    flex: 1;\r\n    padding: 6px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-card-actions button:first-child {\r\n    background-color: #edec5b;\r\n    color: rgb(0, 0, 0);\r\n  }\r\n  \r\n  .order-card-actions button:nth-child(2) {\r\n    background-color: #070707;\r\n    color: white;\r\n  }\r\n  \r\n  .order-card-actions button:last-child {\r\n    background-color: #ffc107;\r\n    color: #333;\r\n  }\r\n  \r\n  .order-card-actions button:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .no-orders {\r\n    text-align: center;\r\n    padding: 40px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n  }\r\n  \r\n  \r\n  .my-orders-page {\r\n    padding: 20px;\r\n    max-width: 1600px;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n  .order-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 30px;\r\n    padding: 15px 20px;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .new-order-btn {\r\n    padding: 10px 20px;\r\n    background-color: #edec5b;\r\n    color: rgb(0, 0, 0);\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .new-order-btn:hover {\r\n    background-color: #f8f894;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(108, 92, 231, 0.3);\r\n  }\r\n  \r\n  .dealer-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .dealer-label {\r\n    color: #666;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .dealer-name {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  \r\n  .dark-theme .my-orders-page {\r\n    background-color: #ffffff;\r\n  }\r\n  \r\n  .dark-theme .orders-list-modal,\r\n  .dark-theme .order-header {\r\n    background-color: #dcdcda;\r\n    border-color: #404040;\r\n  }\r\n  \r\n  .dark-theme .order-card {\r\n    background-color: #b5babd;\r\n    border-color: #404040;\r\n  }\r\n  \r\n  .dark-theme .order-card-header {\r\n    background-color: #fffefe;\r\n  }\r\n  \r\n  .dark-theme .order-number,\r\n  .dark-theme .order-card-body div {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .dealer-label {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .dealer-name {\r\n    color: #000000;\r\n  }\r\n  \r\n  \r\n  @media (max-width: 768px) {\r\n    .order-header {\r\n      flex-direction: column;\r\n      gap: 15px;\r\n      align-items: stretch;\r\n    }\r\n    \r\n    .header-left {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .orders-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n  \r\n.my-orders-page .confirm-dialog-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1100;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n    width: 90%;\r\n    max-width: 600px;\r\n    max-height: 80vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px 20px;\r\n    border-bottom: 1px solid #e9ecef;\r\n    background-color: white;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-header h3 {\r\n    margin: 0;\r\n    color: #333;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n    color: #999;\r\n    transition: color 0.2s;\r\n    padding: 0;\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-close:hover {\r\n    color: #dc3545;\r\n    background-color: #f8f9fa;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-message {\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    flex: 1;\r\n    max-height: calc(80vh - 120px);\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-message::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-message::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-message::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-message::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 8px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-label {\r\n    font-weight: 500;\r\n    color: #666;\r\n    text-align: left;\r\n    flex: 1;\r\n  }\r\n  \r\n  .my-orders-page .confirm-value {\r\n    font-weight: 600;\r\n    color: #333;\r\n    text-align: right;\r\n    flex: 1;\r\n    margin-left: 15px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line.full-width {\r\n    justify-content: center;\r\n    font-weight: 500;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line.full-width.highlight {\r\n    color: #080808;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    margin-top: 10px;\r\n    padding-top: 10px;\r\n    border-top: 1px solid #e9ecef;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line.full-width.position-title {\r\n    color: #edec5b;\r\n    font-weight: 600;\r\n    margin-top: 15px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line.indented {\r\n    margin-left: 20px;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line.indented .confirm-label {\r\n    color: #0e0d0d;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-line.indented .confirm-value {\r\n    color: #080808;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 15px;\r\n    padding: 15px 20px;\r\n    border-top: 1px solid #e9ecef;\r\n    background-color: white;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons button {\r\n    flex: 1;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons .confirm-btn {\r\n    background-color: #edec5b;\r\n    color: #333;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons .confirm-btn:hover:not(:disabled) {\r\n    background-color: #f8f894;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons .confirm-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons .cancel-btn {\r\n    background-color: #6c757d;\r\n    color: white;\r\n  }\r\n  \r\n  .my-orders-page .confirm-dialog-buttons .cancel-btn:hover {\r\n    background-color: #5a6268;\r\n  }\r\n  \r\n  \r\n  .dark-theme .my-orders-page .confirm-dialog {\r\n    background-color: #f7f6f6;\r\n  }\r\n  \r\n  .dark-theme .my-orders-page .confirm-dialog-header {\r\n    background-color: #faf4f4;\r\n    border-bottom-color: #404040;\r\n  }\r\n  \r\n  .dark-theme .my-orders-page .confirm-dialog-header h3 {\r\n    color: #0e0d0d;\r\n  }\r\n  \r\n  .dark-theme .my-orders-page .confirm-label {\r\n    color: #0c0c0c;\r\n  }\r\n  \r\n  .dark-theme .my-orders-page .confirm-value {\r\n    color: #0f0f0f;\r\n  }\r\n  \r\n  .dark-theme .my-orders-page .confirm-dialog-buttons {\r\n    background-color: #fcfafa;\r\n    border-top-color: #404040;\r\n  }\r\n  \r\n.accessories-details-panel {\r\n    margin-top: 10px;\r\n    background-color: #6c757d;\r\n    border-radius: 6px;\r\n    padding: 10px;\r\n  }\r\n  \r\n  \r\n  .accessories-details-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 8px 0;\r\n    margin-bottom: 8px;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n    color: white;\r\n  }\r\n  \r\n  .accessories-details-header span:first-child {\r\n    flex: 3;\r\n    text-align: left;\r\n  }\r\n  \r\n  .accessories-details-header span:last-child {\r\n    flex: 1;\r\n    text-align: right;\r\n  }\r\n  \r\n  \r\n  .accessories-two-columns {\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .accessories-column {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  \r\n  .accessories-details-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 8px 0;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  }\r\n  \r\n  .accessories-details-row:last-child {\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .accessory-name {\r\n    flex: 3;\r\n    font-size: 12px;\r\n    color: white;\r\n    text-align: left; \r\n    word-break: break-word;\r\n    padding-right: 10px;\r\n  }\r\n  \r\n  .accessory-quantity {\r\n    flex: 1;\r\n    text-align: right;\r\n    font-size: 12px;\r\n    color: white;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  \r\n  @media (max-width: 768px) {\r\n    .accessories-two-columns {\r\n      flex-direction: column;\r\n      gap: 8px;\r\n    }\r\n    \r\n    .accessories-details-header span:first-child,\r\n    .accessory-name {\r\n      flex: 2;\r\n    }\r\n    \r\n    .accessories-details-header span:last-child,\r\n    .accessory-quantity {\r\n      flex: 0.8;\r\n    }\r\n  }\r\n\r\n  \r\n\r\n  \r\n.order-info-section {\r\n  background: #f8f9fa;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.order-info-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.order-info-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.order-info-row .info-label {\r\n  font-weight: 500;\r\n  color: #666;\r\n}\r\n\r\n.order-info-row .info-value {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.draft {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.confirmed {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.archived {\r\n  background: #e2e3e5;\r\n  color: #383d41;\r\n}\r\n\r\n.order-items-section h4 {\r\n  margin: 0 0 15px 0;\r\n  color: #333;\r\n  font-size: 16px;\r\n}\r\n\r\n.order-item-detail-card {\r\n  background: white;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 8px;\r\n  margin-bottom: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.order-item-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 15px;\r\n  background: #f8f9fa;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.order-item-header:hover {\r\n  background: #e9ecef;\r\n}\r\n\r\n.order-item-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.item-number {\r\n  background: #edec5b;\r\n  color: #333;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.item-system {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.item-color {\r\n  font-weight: normal;\r\n  color: #666;\r\n  margin-left: 4px;\r\n}\r\n\r\n.order-item-summary {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.item-quantity {\r\n  color: #666;\r\n  font-size: 13px;\r\n}\r\n\r\n.item-sum {\r\n  font-weight: 700;\r\n  color: #070707;\r\n  font-size: 14px;\r\n}\r\n\r\n.expand-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.order-item-details {\r\n  padding: 15px;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.detail-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.detail-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.detail-value {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.total-row .detail-value {\r\n  font-weight: 700;\r\n  color: #edec5b;\r\n}\r\n\r\n.total-value {\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n.accessories-section {\r\n  background: #f5f5f5;\r\n  border-radius: 6px;\r\n  padding: 10px;\r\n  margin: 10px 0;\r\n}\r\n\r\n.accessories-title {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #555;\r\n  margin-bottom: 8px;\r\n  padding-bottom: 5px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.accessory-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 4px 0;\r\n  font-size: 12px;\r\n}\r\n\r\n.accessory-name {\r\n  flex: 2;\r\n  color: #fdfdfd;\r\n}\r\n\r\n.accessory-quantity {\r\n  flex: 0.5;\r\n  text-align: center;\r\n  color: #666;\r\n}\r\n\r\n.accessory-sum {\r\n  flex: 0.8;\r\n  text-align: right;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.accessories-total {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 8px;\r\n  padding-top: 6px;\r\n  border-top: 1px solid #ddd;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.item-notes-section {\r\n  margin-top: 10px;\r\n  padding: 8px;\r\n  background: #fff3cd;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.notes-label {\r\n  font-weight: 600;\r\n  color: #856404;\r\n  margin-right: 8px;\r\n}\r\n\r\n.notes-value {\r\n  color: #856404;\r\n}\r\n\r\n\r\n.order-total-section {\r\n  margin-top: 20px;\r\n  padding-top: 15px;\r\n  border-top: 2px solid #e9ecef;\r\n}\r\n\r\n.total-row.final {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #050505;\r\n}\r\n\r\n.order-notes-section {\r\n  margin-top: 15px;\r\n  padding: 12px;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n}\r\n\r\n.order-notes-section .notes-label {\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.order-notes-section .notes-value {\r\n  color: #555;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 25px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pagination button {\r\n  padding: 8px 14px;\r\n  border: 1px solid #ddd;\r\n  background: white;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  font-size: 14px;\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n  background: #edec5b;\r\n  color: #333;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.pagination button.active {\r\n  background: #edec5b;\r\n  color: #333;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
